module.exports = __webpack_public_path__ + "static/img/4.6b7aa55.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/sp/4.png
// module id = A8fC
// module chunks = 0